import { render } from "./ContratoGeneral.vue?vue&type=template&id=5f9443c8"
import script from "./ContratoGeneral.vue?vue&type=script&lang=js"
export * from "./ContratoGeneral.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__